import React, { useState, useEffect } from 'react';
import './AWSIcon.css';

const AWSIcon = ({ service, isVisible }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setShow(true);
    } else {
      const timer = setTimeout(() => setShow(false), 20000);
      return () => clearTimeout(timer);
    }
  }, [isVisible]);

  if (!show && !isVisible) return null;

  return (
    <div className={`aws-icon-container ${isVisible ? 'fade-in' : 'fade-out'}`}>
        {/* {console.log(`/aws_icons/${service}.svg`)} */}
      <img 
        src={`/aws_icons/${service}.svg`} 
        alt={`${service} icon`}
        className="aws-icon"
      />
    </div>
  );
};

export default AWSIcon;